import { useMemo } from 'react';

import { createStatusToastApi } from '../toast/createStatusToastApi';
import {
  StatusToastApiOptions,
  StatusToastController,
} from '../toast/statusToastController';

export function useStatusToast(
  toast: StatusToastController,
  options: StatusToastApiOptions,
) {
  return useMemo(
    () => createStatusToastApi(toast, options),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [toast, options.defaultPosition],
  );
}
